import { render } from "./CallRequestCard.vue?vue&type=template&id=890a0344"
import script from "./CallRequestCard.vue?vue&type=script&lang=js"
export * from "./CallRequestCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__